module.exports = __webpack_public_path__ + "static/media/mercat.8c08cb46.svg";